import { Bell, CheckCircle2 } from "lucide-react";
import { Link } from "react-router-dom";

export const ReminderBanner = ({ status }) => {
  if (!status) return null;
  const Icon = status.due ? Bell : CheckCircle2;

  return (
    <section className={`rounded-2xl border p-5 shadow-[0_8px_30px_rgba(26,54,38,0.04)] ${status.due ? "border-[#C87961] bg-[#FFF8F3]" : "border-[#E5E1D8] bg-white"}`} data-testid="dashboard-reminder-banner">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex gap-4">
          <span className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-full ${status.due ? "bg-[#C87961] text-white" : "bg-[#F9F6F0] text-[#1A3626]"}`} data-testid="dashboard-reminder-icon">
            <Icon size={20} />
          </span>
          <div>
            <h2 className="font-serif-display text-2xl font-semibold text-[#1A3626]" data-testid="dashboard-reminder-title">{status.title}</h2>
            <p className="mt-1 text-sm leading-relaxed text-[#4A5D4E]" data-testid="dashboard-reminder-detail">{status.detail}</p>
          </div>
        </div>
        <Link to={status.due ? "/reflect" : "/reminders"} className="rounded-full bg-[#1A3626] px-5 py-2 text-center text-sm font-medium text-white transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-[#4A5D4E]" data-testid="dashboard-reminder-action-link">
          {status.due ? "Reflect now" : "Adjust reminder"}
        </Link>
      </div>
    </section>
  );
};